export default function About() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-8">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-3">
            关于我们
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">关于52吃瓜网</h2>
        </div>

        <div className="bg-background-100 rounded-2xl p-6 md:p-10 border border-background-200/70">
          <div className="flex flex-col lg:flex-row items-start gap-8">
            <div className="flex-1">
              <p className="text-foreground-600 leading-relaxed mb-4">
                52吃瓜网成立于2020年，是国内领先的泛娱乐八卦资讯聚合平台。我们以"吃瓜"文化为切入点，致力于为中文互联网用户提供全面、及时、有趣的娱乐八卦内容。
              </p>
              <p className="text-foreground-600 leading-relaxed mb-4">
                平台覆盖明星艺人、综艺影视、网络红人、社会热点等多个垂直领域，每日由专业编辑团队筛选整理来自数百个信息源的优质内容，确保每一条资讯都经过交叉验证。
              </p>
              <p className="text-foreground-600 leading-relaxed mb-5">
                截至2026年7月，52吃瓜网月活跃用户突破800万，累计收录八卦资讯超过50万条，日均更新量保持120条以上，已成为中文互联网最活跃的吃瓜社区之一。
              </p>
              <div className="flex flex-wrap gap-4">
                <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-primary-50 text-primary-700 text-sm">
                  <i className="ri-user-heart-line"></i>
                  <span className="font-semibold">800万+</span> 月活用户
                </div>
                <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-accent-50 text-accent-700 text-sm">
                  <i className="ri-article-line"></i>
                  <span className="font-semibold">50万+</span> 收录资讯
                </div>
                <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-secondary-50 text-secondary-700 text-sm">
                  <i className="ri-calendar-check-line"></i>
                  <span className="font-semibold">2000天+</span> 连续运营
                </div>
              </div>
            </div>
            <div className="w-full lg:w-64 shrink-0">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20brand%20illustration%20of%20a%20modern%20digital%20media%20platform%2C%20soft%20coral%20and%20cream%20tones%2C%20abstract%20flowing%20shapes%20representing%20information%20flow%2C%20clean%20background%2C%20editorial%20style%2C%20professional%20yet%20approachable&width=512&height=384&seq=about-brand-2026-x1&orientation=landscape"
                alt="52吃瓜网品牌形象"
                className="w-full rounded-xl object-cover"
                onError={(e) => {
                  const t = e.currentTarget;
                  t.style.display = 'none';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}